import { render } from "./IconChevronLeft.vue?vue&type=template&id=0dcc4e7c"
import script from "./IconChevronLeft.vue?vue&type=script&lang=js"
export * from "./IconChevronLeft.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconChevronLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dcc4e7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dcc4e7c', __exports__)) {
    api.reload('0dcc4e7c', __exports__)
  }
  
  module.hot.accept("./IconChevronLeft.vue?vue&type=template&id=0dcc4e7c", () => {
    api.rerender('0dcc4e7c', render)
  })

}


export default __exports__